import { CacheKeys } from 'utils/cacheKeys';
import { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { queryClient } from 'providers/AllProviders';

type BusinessContextType = {
  selectedBusiness: number | null;
  setSelectedBusiness: (business: number | null) => void;
  selectedLocation: number | null;
  setSelectedLocation: (business: number | null) => void;
};

const BusinessContext = createContext<BusinessContextType | undefined>(undefined);

type BusinessProviderProps = {
  children: ReactNode;
};

export const BusinessProvider = ({ children }: BusinessProviderProps) => {
  let businessIds;
  if (localStorage.getItem(CacheKeys.businessIds)) {
    businessIds = JSON.parse(localStorage.getItem(CacheKeys.businessIds) ?? '');
  }
  const selectFirstBusinessDefault = businessIds?.length > 0 ? businessIds[0] : null;
  const [selectedBusiness, setSelectedBusiness] = useState<number | null>(selectFirstBusinessDefault);

  useEffect(() => {
    queryClient.resetQueries();
  }, [selectedBusiness]);

  let locationIds;
  if (localStorage.getItem(CacheKeys.locationIds)) {
    locationIds = JSON.parse(localStorage.getItem(CacheKeys.locationIds) ?? '');
  }
  const selectFirstLocationDefault = locationIds?.length > 0 ? locationIds[0] : null;
  const [selectedLocation, setSelectedLocation] = useState<number | null>(selectFirstLocationDefault);

  return (
    <BusinessContext.Provider
      value={{
        selectedBusiness,
        setSelectedBusiness,
        selectedLocation,
        setSelectedLocation
      }}
    >
      {children}
    </BusinessContext.Provider>
  );
};

export const useBusiness = () => {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusiness must be used within a BusinessProvider');
  }
  return context;
};
